<img class="up-down-arrow" [class.up-down-arrow--down]="!up" [src]="IconPath.UpArrow" />
